export default __webpack_public_path__ + "static/media/notification.3e9a7073.mp3";